import React from 'react';
import {Route} from 'react-router-dom';
import ProgressForm from 'components/forms/ProgressForm';
import Endorsements from 'components/forms/application_upgrade/Endorsements.jsx';
import {FormNames, FormTypes} from '../../../constants';
import {StatePrompt} from 'components/forms';
import PaymentAndDelivery from 'components/forms/application_original/PaymentAndDelivery';

const FormApplicationUpgrade = () => {
    const node = FormTypes.APPLICATION_UPGRADE.toLowerCase();
    const applicationType = 'upgrade';

    return (
        <ProgressForm
            title={FormNames.APPLICATION_UPGRADE}
            node={node}
            addForm={false}
        >
            <StatePrompt />
            <Route path={`/forms/${node}/endorsements`}>
                <Endorsements documentType={node} {...{applicationType}} />
            </Route>
            <Route path={`/forms/${node}/paymentdelivery`}>
                <PaymentAndDelivery {...{applicationType}} />
            </Route>
        </ProgressForm>
    );
};

export default FormApplicationUpgrade;
